import React from 'react'

import EditSubCategoryForm from '../../modules/SubCategory/components/EditSubCategoryForm'
export default function EditSubCategoryPage() {
  return <EditSubCategoryForm />
}
